import { Maybe } from 'monet';
import type { RuleSetId } from '../../../model';
import type { State } from '../../types';
import { getUI } from '../base';

export const isLoading = (state: State): boolean => getUI(state).isLoading;

export const getGlobalError = (state: State): string | undefined =>
	Maybe.fromNull(getUI(state).globalError)
		// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
		.map((anError) => anError.errors[0].errorMessage)
		.cata(
			() => undefined,
			(err) => err,
		);

export const hasGlobalError = (state: State): boolean => {
	const globalError = getGlobalError(state);
	return !!globalError;
};

export const isDeleteDialogOpen = (state: State, ruleSetId: RuleSetId): boolean =>
	Maybe.fromNull(getUI(state).deleteDialogOpenForRuleSetId)
		.map((dialogOpenForRuleSetId) => dialogOpenForRuleSetId === ruleSetId)
		.orSome(false);

export const isDeleting = (state: State, ruleSetId: RuleSetId): boolean =>
	Maybe.fromNull(getUI(state).ruleSetBeingDeleted)
		.map((ruleSetIsBeingDeletedForId) => ruleSetIsBeingDeletedForId === ruleSetId)
		.orSome(false);
